import { Card, Text } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { useEffect } from "react";
import { StyledContainerInset } from "src/components/common/StyledComponents/BackgroundContainer";
import { StyledContainer } from "src/components/common/StyledComponents/Container";
import { UsersTable } from "src/components/Tables/UsersTable";
import useAdminSettings from "src/hooks/useAdminSettings";
import useResponsive from "src/hooks/useResponsive";
import { UserManagement } from "src/interfaces";
import { FONT_SIZES } from "src/utils/styles";

const UserManagementScreen = () => {
  const {
    users,
    getUsers,
    changeUserStatus,
    promoteUserLevel,
    updateUserSubjects,
    deleteUserAccount,
    loading,
    updateUserPassword,
    createParent,
    createLearner,
  } = useAdminSettings();
  const { backgroundColor, backgroundColorExterior, isMobile } =
    useResponsive();

  useEffect(() => {
    getUsers();
  }, []);

  const deactivateAccount = (item: UserManagement) => {
    changeUserStatus(item);
  };

  const handlePromoteLevel = (user: UserManagement) => {
    return promoteUserLevel(user);
  };

  const handleUpdateSubjects = async (
    user: UserManagement,
    subjectIds: number[]
  ) => {
    return updateUserSubjects(user, subjectIds);
  };

  const handleDeleteUser = (user: UserManagement) => {
    return deleteUserAccount(user);
  };

  const handleUpdatePassword = (user: UserManagement, password: string) => {
    return updateUserPassword(user, password);
  };

  const handleCreateParent = (
    name: string,
    email: string,
    password: string,
    phone?: string
  ) => {
    return createParent(name, email, password, phone);
  };

  const handleCreateLearner = (
    name: string,
    username: string,
    password: string,
    level: number,
    subjectIds: number[],
    school: string,
    dateOfBirth: string,
    parentEmail: string,
    avatarPath?: string
  ) => {
    return createLearner(
      name,
      username,
      password,
      level,
      subjectIds,
      school,
      dateOfBirth,
      parentEmail,
      avatarPath
    );
  };

  return (
    <StyledContainer theme={{ backgroundColor: backgroundColorExterior }}>
      <StyledContainerInset theme={{ backgroundColor: backgroundColor }}>
        <Notifications position="top-center" limit={isMobile ? 1 : 5} zIndex={9999} />
        <div className="p-4 h-[100vh] overflow-y-auto">
          <Text size={FONT_SIZES.h1} fw={600}>
            User Management
          </Text>
          <Text c="dimmed" size={14}>
            One place for all users of MYAi
          </Text>
          <Card bg={backgroundColor} p={0} my={"md"}>
            <Text>Existing Users</Text>
          </Card>
          <UsersTable
            onDeactivate={deactivateAccount}
            data={users}
            onPromoteLevel={handlePromoteLevel}
            onDeleteUser={handleDeleteUser}
            onUpdateSubjects={handleUpdateSubjects}
            onUpdatePassword={handleUpdatePassword}
            loading={loading}
            onCreateParent={handleCreateParent}
            onCreateLearner={handleCreateLearner}
          />
        </div>
      </StyledContainerInset>
    </StyledContainer>
  );
};

export default UserManagementScreen;
